import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";
import { SkuSearch, SkuSearchResult } from "@/types/Sku";

export const skuGroupApi = createApi({
    reducerPath: "skuGroupApi",
    baseQuery: adminBaseQueryWrapper,
    tagTypes: ["skuGroup"],
    keepUnusedDataFor: 0,
    endpoints: (builder) => ({

        getItemBySkuGroupId: builder.query({
            query: (id) => `/skugroup/${id}`,
            providesTags: ["skuGroup"],
        }),

        // getAllSku: builder.query<SkuResponse[], any>({
        //   query: () => `/sku`,
        //   providesTags: ["sku"],
        // }),
        searchSkuGroup: builder.query<SkuSearchResult, SkuSearch>({
          query: (input) => ({
            url: `/skugroup/search`,
            method: "POST",
            body: { ...input, export: false },
          }),
          providesTags: ["skuGroup"],
        }),
        exportSkuGroup: builder.mutation<Blob, SkuSearch>({
          query: (input) => ({
            url: `/sku/search`,
            method: "POST",
            body: { ...input, export: true },
            responseHandler: (response: Response) => response.blob(),
          }),
        }),
        // getSkuById: builder.query<any, any>({
        //   query: ({ id }) => `/sku/${id}`,
        //   providesTags: ["sku"],
        // }),
        createSkuGroup: builder.mutation<void, any>({
            query: (data) => ({
                url: `/skugroup/create`,
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["skuGroup"],
        }),
        updateSkuGroup: builder.mutation<void, any>({
            query: ({ id, data }) => ({
                url: `/skugroup/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["skuGroup"],
        }),
        getSkuGroupItemBySku: builder.query<any, any>({
            query: ({ sku_id }) => `/skugroup/by-skugroup/${sku_id}`,
            providesTags: ["skuGroup"],
        }),
    })
})


export const {
    useCreateSkuGroupMutation,
    useUpdateSkuGroupMutation,
    useGetItemBySkuGroupIdQuery,
    useGetSkuGroupItemBySkuQuery,
    useSearchSkuGroupQuery,
    useExportSkuGroupMutation

} = skuGroupApi;
